import { render, staticRenderFns } from "./CensusListView.vue?vue&type=template&id=6623959a&"
import script from "./CensusListView.vue?vue&type=script&lang=ts&"
export * from "./CensusListView.vue?vue&type=script&lang=ts&"
import style0 from "./CensusListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports